
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { makeStyles } from "@mui/styles";
import { FilterList as FilterListIcon, InfoOutlined as InfoOutlinedIcon } from "@mui/icons-material";
import { spacing } from "@mui/system";
import React from "react";
import { CSVDownloadButton } from "../../utils/csvUtils";
import { dateFormatter, dateFormatterNoTime, dateTime } from "../../setup/helpers";
import styled from "styled-components";

import {
  Checkbox, Box, IconButton, Link, Breadcrumbs as MuiBreadcrumbs, Divider as MuiDivider, Paper as MuiPaper, Table, TableBody, TableContainer, TableCell,
  TableHead, TablePagination, Chip, TableRow, TableSortLabel, Toolbar, Tooltip, Typography, FormControlLabel, Switch, Menu, MenuItem, TextField as MuiTextField, Button as MuiButton,
  FormControl, InputLabel, Select, Input,
} from "@mui/material";

const Button = styled(MuiButton)(spacing);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// Tool Bar Expects: {tableTitle, fieldTitles(Array), fieldTypes(Array), fieldNames(Array), numSelected }
export function EnhancedTableToolbar({
  fieldTitles,
  fieldTypes,
  fieldNames,
  handleNewItemCreation,
  handleSaveData,
  handleRefreshData,
  handleDeletData,
  tableTitle,
  numSelected = 0,
  itemsSelected = null,
  readOnly,
  canSave,
  canAddItems,
  canExport,
  selectedItems,
  exportData,
  CustomToolbar,
  customSelectItemActionButtonLabel,
  customHandleSelectItemAction,
  handleCondOnSelectButtonOnClickMethodMethod,
  CustomFilters,
  activeFilters,
  condOnSelectButtons,
  ConditionalOnSelectToolbar,
  canDelete,
  canDeleteEvaluator,
  getDeleteBlockedReason,
  ConfirmDeletion,
  toUpdateLength,
  saveDisabled = false,
}) {
  const formatConfirmCellValue = (value, fieldType) => {
    if (value == null || value === "") {
      return value;
    }
    if (React.isValidElement(value)) {
      return value;
    }
    switch (fieldType) {
      case "dateLabelNoTime":
      case "dateLabelSmall":
      case "dateLabelSmallPopup":
      case "dateField":
        return dateFormatterNoTime(value);
      case "dateLabel":
        return dateFormatter(value);
      case "dateTimeLabel":
        return dateTime(value);
      default:
        return value;
    }
  };

  const renderConfirmCellValue = (currentObject, fieldName, fieldType) => {
    if (!Array.isArray(fieldName)) {
      return formatConfirmCellValue(currentObject[fieldName], fieldType);
    }
    return fieldName.map((field, nestedIndex) => (
      <Typography component={'span'} name={field} key={field}>
        {formatConfirmCellValue(
          currentObject[field],
          Array.isArray(fieldType) ? fieldType[nestedIndex] : fieldType
        )}
      </Typography>
    ));
  };

  const useStyles = makeStyles((theme) => {
    return {
      dropdown: {
        width: "14rem",
      },
      modalcontainer: {
        width: "60%",
        height: "60%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "15px",
        padding: "3rem",
      },
      link: {
        textDecoration: "none",
        color: "#ffffff",
        "&:hover": {
          fontWeight: "bold",
          textDecoration: "underline",
        },
      },

      rightSideHeader: {
        display: "flex",
        alignItems: "flex-end",
        flexDirection: "row",
        justifyContent: "flex-end",
      },

      leftSideHeader: {
        display: "flex",
        justifyContent: "left",
        alignItems: "left",
      },
      tableHeaderText: {
        fontWeight: "bold",
      },
      exportBtn: {
        paddingRight: 2,
      },
      filterPopupContent: {
        marginBottom: "20px",
        overflowY: "visible",
      },
      filterPopup: {
        height: "auto",
      },
    };
  });
  const classes = useStyles();

  const handleDeleteClick = (event) => {
    handleDeletData();
    setConfirmDeltionOpen(false);
  };

  const handleAddNewItem = () => {
    handleNewItemCreation();
  };

  const handleSaveClick = () => {
    handleSaveData();
  };

  const handleRefresh = () => {
    handleRefreshData();
  };

  const [filtersOpen, setFiltersOpen] = React.useState(false);
  const [confirmDeltionOpen, setConfirmDeltionOpen] = React.useState(false);

  const handleFiltersClickOpen = () => {
    setFiltersOpen(true);
  };

  const handleFiltersClose = () => {
    setFiltersOpen(false);
  };


  const handleConfirmDeletionClose = () => {
    setConfirmDeltionOpen(false);
  };
  const handleConfirmDeletionClickOpen = () => {
    setConfirmDeltionOpen(true);
  };


  let deletableItems = 0;
  return (
    <>
      <Toolbar>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>
          <Box sx={{
            flex: { lg: '5 1 41.67%', md: '1 1 100%', sm: '1 1 100%' },
            pr: { lg: 2 },
            mb: { md: 2, lg: 0 }
          }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box>
                <Typography component={"span"} variant="h5" style={{ color: 'inherit' }} id="tableTitle">
                  {tableTitle}
                </Typography>
                {numSelected > 0 && (
                  <Typography component={"span"} style={{ color: 'inherit' }} variant="h6">
                    {" "}
                    {numSelected} selected{" "}
                  </Typography>
                )}
              </Box>
              <Box className={"mb-2"}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                  {activeFilters.map((filter, index) => {
                    if (filter != null && filter != "All") {
                      return (
                        <Chip
                          key={index}
                          label={filter}
                          size="small"
                          onClick={handleFiltersClickOpen}
                          color="primary"
                        />
                      )
                    }
                  })
                  }
                  {CustomFilters && (
                    <Chip
                      icon={<FilterListIcon />}
                      label="Filters"
                      size="small"
                      onClick={handleFiltersClickOpen}
                      color="primary"
                      variant="outlined"
                    />
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
          <Box sx={{
            flex: { lg: '7 1 58.33%', md: '1 1 100%', sm: '1 1 100%' }
          }}>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'flex-end', alignItems: 'flex-end' }}>
              {CustomFilters && (
                <Tooltip title="Filter list">
                  <IconButton
                    aria-label="Filter list"
                    onClick={handleFiltersClickOpen}
                  >
                    <FilterListIcon />
                  </IconButton>
                </Tooltip>
              )}
              {canAddItems && (
                <Button mr={1} variant="contained" onClick={handleAddNewItem}>
                  New Item
                </Button>
              )}
              {(canSave /* showing of save button only when toUpdate size not 0? */) && (
                <Button
                  mr={1}
                  variant="contained"
                  color="secondary"
                  onClick={handleSaveClick}
                  disabled={
                    saveDisabled ||
                    (Number.isFinite(toUpdateLength) && toUpdateLength === 0)
                  }
                  aria-disabled={
                    saveDisabled ||
                    (Number.isFinite(toUpdateLength) && toUpdateLength === 0)
                  }
                >
                  Save
                </Button>
              )}
              {numSelected > 0 && customHandleSelectItemAction ? (
                <Button
                  mr={1}
                  variant="contained"
                  color="primary"
                  onClick={customHandleSelectItemAction}
                >
                  {customSelectItemActionButtonLabel ||
                    "Unknown Custom Action Button LBL"}
                </Button>
              ) : (
                <></>
              )}
              {numSelected > 0 &&
                condOnSelectButtons &&
                condOnSelectButtons.map((condButton, key) => {
                  if (condButton.conditionalShowStatement()) {
                    return (
                      <Button
                        key={key}
                        mr={1}
                        variant="contained"
                        color="primary"
                        onClick={() =>
                          handleCondOnSelectButtonOnClickMethodMethod(
                            condButton.onSelectMethod
                          )
                        }
                      >
                        {condButton.buttonLabel ||
                          "Unknown Conditional Button LBL"}
                      </Button>
                    );
                  } else {
                    return <></>;
                  }
                })}
              {(numSelected > 0 && canDelete) && (
                <>
                  {ConfirmDeletion ?
                    <Button
                      mr={1}
                      variant="contained"
                      color="primary"
                      onClick={handleConfirmDeletionClickOpen}
                    >
                      Delete
                    </Button>
                    :
                    <Button
                      mr={1}
                      variant="contained"
                      color="primary"
                      onClick={handleDeleteClick}
                    >
                      Delete
                    </Button>
                  }
                </>
              )}
              {(numSelected > 0 && ConditionalOnSelectToolbar) && (
                <ConditionalOnSelectToolbar />
              )}
              {(canExport && exportData.length > 0) && (
                <Button variant="contained" color="secondary">
                  <CSVDownloadButton
                    filename={`${tableTitle}-${moment.utc().format('MMMM Do YYYY, h:mm:ss a')}.csv`}
                    data={exportData}
                  >
                    Export
                  </CSVDownloadButton>
                </Button>
              )}
            </Box>
            {CustomToolbar && CustomToolbar}
          </Box>
        </Box>
      </Toolbar>
      {ConfirmDeletion && (
        <Dialog
          className={classes.filterPopup}
          open={confirmDeltionOpen}
          TransitionComponent={Transition}
          fullWidth={"lg"}
          maxWidth={"lg"}
          keepMounted
          onClose={handleConfirmDeletionClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">
            Are you sure you would like to delete the following items? (Red Items are unable to be deleted at this time)
          </DialogTitle>
          <DialogContent className={classes.filterPopupContent}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              <Box>
                <TableContainer>
                  <Table
                    aria-labelledby="tableTitle"
                    size={"small"}
                    aria-label="enhanced table"
                  >
                    <TableHead>
                      <TableRow>
                        {fieldTitles.map((title, index) => {
                          return (
                            <TableCell
                              component="th"
                              key={index}
                              align={"left"}
                              padding={"default"} // Padding changing not yet implemented
                              className={classes.tableHeaderText}
                            >
                              {fieldNames[index] && fieldNames[index] != "" &&
                                <TableSortLabel>
                                  {title}
                                </TableSortLabel>
                              }
                            </TableCell>
                          )
                        }
                        )}
                        <TableCell padding="none" />
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <>
                        {selectedItems.map((currentObject) => {
                          let canDelete = canDeleteEvaluator(currentObject);
                          const blockedReason = !canDelete
                            ? (typeof getDeleteBlockedReason === "function" && getDeleteBlockedReason(currentObject))
                              || "This item cannot be deleted at this time."
                            : null;
                          if (canDelete) {
                            deletableItems++;
                          }
                          return (
                            <TableRow
                              hover
                              tabIndex={-1}
                              key={"validateDelete_" + currentObject.id}
                              style={canDelete ? undefined : { backgroundColor: '#ffaaaa' }}
                            >
                              {fieldNames.map((fieldName, fieldIndex) => (
                                <TableCell align="left" key={"validateDelete_" + currentObject.id + "Cell" + fieldIndex}>
                                  <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'stretch' }}>
                                    {Array.isArray(fieldName) ? (
                                      renderConfirmCellValue(currentObject, fieldName, fieldTypes[fieldIndex])
                                    ) : (
                                      <Typography component={'span'} name={fieldName}>
                                        {renderConfirmCellValue(currentObject, fieldName, fieldTypes[fieldIndex])}
                                      </Typography>
                                    )}
                                  </Box>
                                </TableCell>
                              ))}
                              <TableCell padding="none" align="right" sx={{ width: 40 }}>
                                {blockedReason && (
                                  <Tooltip title={blockedReason} arrow placement="top">
                                    <IconButton size="small" aria-label={blockedReason}>
                                      <InfoOutlinedIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </TableCell>
                            </TableRow>
                          )
                        })
                        }
                      </>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
              <Box sx={{ display: 'flex', gap: 2 }}>
                {deletableItems > 0 ?
                  <Box sx={{ flex: '1 1 50%' }}>
                    <Button
                      mr={1}
                      variant="contained"
                      color="primary"
                      onClick={handleDeleteClick}
                    >
                      Confirm
                    </Button>
                  </Box>
                  :
                  <Box sx={{ flex: '1 1 50%' }}>
                    <Button
                      mr={1}
                      variant="contained"
                      fullWidth={true}
                      color="primary"
                      disabled={true}
                    >
                      No valid items selected for deletion
                    </Button>
                  </Box>
                }
                <Box sx={{ flex: '1 1 50%' }}>
                  <Button
                    mr={1}
                    variant="contained"
                    fullWidth={true}
                    color="secondary"
                    onClick={handleConfirmDeletionClose}
                  >
                    Cancel
                  </Button>
                </Box>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      )
      }
      {CustomFilters && (
        <Dialog
          className={classes.filterPopup}
          open={filtersOpen}
          TransitionComponent={Transition}
          fullWidth={"lg"}
          maxWidth={"lg"}
          keepMounted
          onClose={handleFiltersClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">Filters</DialogTitle>
          <DialogContent className={classes.filterPopupContent}>
            {CustomFilters}
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}

export function EnhancedTableHead({
  fieldTitles,
  showNumber,
  fieldTypes,
  fieldNames,
  onSelectAllClick,
  // new order by item {fieldname: name, direction: dir (asc, desc)}
  orderBy,
  numSelected,
  rowCount,
  onRequestSort,
  readOnly,
  singleSelectMode = false,
  strongHeaders = false,
}) {
  const useStyles = makeStyles((theme) => {
    return {
      tableHeaderText: {
        fontSize: "105%",
      },
    };
  });
  const classes = useStyles();


  // new order by item {fieldname: name, direction: dir (asc, desc)}
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const handleSelectAllClicked = (event) => {
    if (onSelectAllClick) {
      onSelectAllClick(event);
    }
  };

  return (
    <TableHead>
      <TableRow>
        {!readOnly && (
          <TableCell padding="checkbox">
            {!singleSelectMode && (
              <Checkbox
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={rowCount > 0 && numSelected === rowCount}
                onChange={handleSelectAllClicked}
                inputProps={{ "aria-label": "select all line items" }}
              />
            )}
          </TableCell>
        )}
        {showNumber && <TableCell style={{ paddingLeft: "0px" }}>#</TableCell>}
        {fieldTitles.map((title, index) => {
          // new order by item {fieldname: name, direction: dir (asc, desc)}
          // Must see if the current field name is a sorted one
          var isColumnForSort = false;
          if (Array.isArray(fieldNames[index])) {
            isColumnForSort = orderBy.find(x => x.fieldname === fieldNames[index][0]);
          }
          else {
            isColumnForSort = orderBy.find(x => x.fieldname === fieldNames[index]);
          }
          return (
            <TableCell
              component="th"
              key={index}
              align={"left"}
              padding={!readOnly ? "none" : "default"} // Padding changing not yet implemented
              sortDirection={isColumnForSort ? isColumnForSort.direction : "asc"}
              className={classes.tableHeaderText}
              sx={strongHeaders ? { fontWeight: 600 } : undefined}
            >
              {fieldNames[index] && fieldNames[index] != "" &&
                <TableSortLabel
                  active={isColumnForSort ? true : false}
                  direction={isColumnForSort ? isColumnForSort.direction : "asc"}
                  onClick={createSortHandler(index)}
                >
                  {title}
                </TableSortLabel>
              }
            </TableCell>
          )
        }
        )}
      </TableRow>
    </TableHead>
  );
}
